export const WORKER_BLOCKS_FETCH_BEGIN = 'syftacp/WORKER_BLOCKS_FETCH_BEGIN' as const
export const WORKER_BLOCKS_FETCH_FAILED = 'syftacp/WORKER_BLOCKS_FETCH_FAILED' as const
export const WORKER_BLOCKS_FETCH_SUCCEEDED = 'syftacp/WORKER_BLOCKS_FETCH_SUCCEEDED' as const
